export default __webpack_public_path__ + "static/media/section-B-1_LS.0863ec04.png";